// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#ff7171","app":"App_app__2K5xB","paper":"App_paper__1PXe4"};